export const FETCH_WHATS_APP_REQUEST = "FETCH_WHATS_APP_REQUEST";
export const FETCH_WHATS_APP_SUCCESS = "FETCH_WHATS_APP_SUCCESS";
export const FETCH_WHATS_APP_FAIL = "FETCH_WHATS_APP_FAIL";

export const CREATE_WHATS_APP_REQUEST = "CREATE_WHATS_APP_REQUEST";
export const CREATE_WHATS_APP_SUCCESS = "CREATE_WHATS_APP_SUCCESS";
export const CREATE_WHATS_APP_FAIL = "CREATE_WHATS_APP_FAIL";

export const SHOW_WHATS_APP_REQUEST = "SHOW_WHATS_APP_REQUEST";
export const SHOW_WHATS_APP_SUCCESS = "SHOW_WHATS_APP_SUCCESS";
export const SHOW_WHATS_APP_FAIL = "SHOW_WHATS_APP_FAIL";

export const UPDATE_WHATS_APP_REQUEST = "UPDATE_WHATS_APP_REQUEST";
export const UPDATE_WHATS_APP_SUCCESS = "UPDATE_WHATS_APP_SUCCESS";
export const UPDATE_WHATS_APP_FAIL = "UPDATE_WHATS_APP_FAIL";
